import jQuery from 'jquery';
import { Directive, Input, Renderer2, ElementRef, OnInit, OnChanges, EventEmitter, Output } from '@angular/core';

import { isFunction } from 'rev-shared/util';
import { DroppableDirective } from './Droppable.AngularDirective';

export const vbDraggableKey = 'vbDraggableData';

export interface IDragData {
	onDrop: (droppable: DroppableDirective) => void;
	droppable?: DroppableDirective;
	data: any;
}

@Directive({
	selector: '[vbDraggable]',
	host: {
		class: 'vb-draggable'
	},
	standalone: false
})
export class DraggableDirective implements OnChanges {
	@Input() public dragOptions: any;
	/**
	 * Can be an object or a function that returns an object.
	 * The object is passed to the drop component
	 */
	@Input() public dragData: any;
	@Input() public dragEnabled: boolean = true;
	@Output() public dragStop: EventEmitter<any> = new EventEmitter();

	private ready: boolean;

	constructor(
		private readonly $element: ElementRef,
		private readonly renderer: Renderer2
	) {
	}

	public ngOnChanges(): void {
		if(!this.dragEnabled || this.ready) {
			return;
		}
		this.ready = true;
		const $el = jQuery(this.$element.nativeElement);
		($el as any).draggable({
			scroll: false,
			helper: 'clone',
			...this.dragOptions,
			start: (e: Event, ui: JQueryUI.DraggableEventUIParams): void => {
				const data = this.dragEnabled ? this.getDragData() : undefined;
				if(data == undefined) {
					e.preventDefault();
					$el.draggable('cancel');
					return;
				}

				this.renderer.addClass(this.$element.nativeElement, 'vb-dragging');

				if (ui.helper?.[0]) {
					this.renderer.addClass(ui.helper[0], 'vb-draggable-helper');
				}

				$el.data(vbDraggableKey, this.getDragData());
			},
			stop: e => {
				const data = $el.data(vbDraggableKey);
				$el.data(vbDraggableKey, null);

				this.dragStop.emit(data);

				this.renderer.removeClass(this.$element.nativeElement, 'vb-dragging');
			}
		});
	}

	private getDragData(): IDragData {
		try {
			const data = isFunction(this.dragData) ? this.dragData() : this.dragData;
			if(data) {
				const dd: IDragData = {
					data,
					onDrop(droppable) {
						dd.droppable = droppable;
					}
				};
				return dd;
			}
		}
		catch(e) {
			console.error('Draggable error: ', e);
		}
	}
}

